"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var invariant_1 = __importDefault(require("invariant"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var warning_1 = __importDefault(require("warning"));
var parseMask_1 = __importDefault(require("./parseMask"));
var processChange_1 = __importDefault(require("./processChange"));
var defer_1 = require("./utils/defer");
var environment_1 = require("./utils/environment");
var helpers_1 = require("./utils/helpers");
var selection_1 = require("./utils/selection");
var string_1 = require("./utils/string");
var InputElement = /** @class */ (function (_super) {
    __extends(InputElement, _super);
    function InputElement(props) {
        var _this = _super.call(this, props) || this;
        _this.focused = false;
        _this.mounted = false;
        _this.previousSelection = null;
        _this.selectionDeferId = null;
        _this.saveSelectionLoopDeferId = null;
        _this.saveSelectionLoop = function () {
            _this.previousSelection = _this.getSelection();
            _this.saveSelectionLoopDeferId = defer_1.defer(_this.saveSelectionLoop);
        };
        _this.runSaveSelectionLoop = function () {
            if (_this.saveSelectionLoopDeferId === null) {
                _this.saveSelectionLoop();
            }
        };
        _this.stopSaveSelectionLoop = function () {
            if (_this.saveSelectionLoopDeferId !== null) {
                defer_1.cancelDefer(_this.saveSelectionLoopDeferId);
                _this.saveSelectionLoopDeferId = null;
                _this.previousSelection = null;
            }
        };
        _this.getInputDOMNode = function () {
            if (!_this.mounted) {
                return null;
            }
            var input = react_dom_1.findDOMNode(_this);
            var isDOMNode = typeof window !== "undefined" && input instanceof window.Element;
            // workaround for react-test-renderer
            // https://github.com/sanniassin/react-input-mask/issues/147
            if (input && !isDOMNode) {
                return null;
            }
            if (input.nodeName !== "INPUT") {
                input = input.querySelector("input");
            }
            if (!input) {
                throw new Error("react-input-mask: inputComponent doesn't contain input node");
            }
            return input;
        };
        _this.getInputValue = function () {
            var input = _this.getInputDOMNode();
            if (!input) {
                return null;
            }
            return input.value;
        };
        _this.setInputValue = function (value) {
            var input = _this.getInputDOMNode();
            if (!input) {
                return;
            }
            _this.value = value;
            input.value = value;
        };
        _this.setCursorToEnd = function () {
            var filledLength = string_1.getFilledLength(_this.maskOptions, _this.value);
            var pos = string_1.getRightEditablePosition(_this.maskOptions, filledLength);
            if (pos !== null) {
                _this.setCursorPosition(pos);
            }
        };
        _this.setSelection = function (start, end, options) {
            if (options === void 0) { options = {}; }
            var input = _this.getInputDOMNode();
            var isFocused = _this.isFocused();
            // don't change selection on unfocused input
            // because Safari sets focus on selection change (#154)
            if (!input || !isFocused) {
                return;
            }
            var deferred = options.deferred;
            if (!deferred) {
                selection_1.setInputSelection(input, start, end);
            }
            if (_this.selectionDeferId !== null) {
                defer_1.cancelDefer(_this.selectionDeferId);
            }
            // deferred selection update is required for pre-Lollipop Android browser,
            // but for consistent behavior we do it for all browsers
            _this.selectionDeferId = defer_1.defer(function () {
                _this.selectionDeferId = null;
                selection_1.setInputSelection(input, start, end);
            });
            _this.previousSelection = {
                start: start,
                end: end,
                length: Math.abs(end - start)
            };
        };
        _this.getSelection = function () {
            var input = _this.getInputDOMNode();
            return selection_1.getInputSelection(input);
        };
        _this.getCursorPosition = function () {
            return _this.getSelection().start;
        };
        _this.setCursorPosition = function (pos) {
            _this.setSelection(pos, pos);
        };
        _this.isFocused = function () {
            return _this.focused;
        };
        _this.getBeforeMaskedValueChangeConfig = function () {
            var _a = _this.maskOptions, mask = _a.mask, maskChar = _a.maskChar, permanents = _a.permanents, formatChars = _a.formatChars;
            var alwaysShowMask = _this.props.alwaysShowMask;
            return {
                mask: mask,
                maskChar: maskChar,
                permanents: permanents,
                alwaysShowMask: !!alwaysShowMask,
                formatChars: formatChars
            };
        };
        _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
            var input = _this.getInputDOMNode();
            // only check for positive match because it will be false negative
            // in case of autofill simulation in tests
            //
            // input.matches throws an exception if selector isn't supported
            try {
                if (input.matches(":-webkit-autofill")) {
                    return true;
                }
            }
            catch (e) { }
            // if input isn't focused then change event must have been triggered
            // either by autofill or event simulation in tests
            if (!_this.focused) {
                return true;
            }
            // if cursor has moved to the end while previousSelection forbids it
            // then it must be autofill
            return (previousSelection.end < previousValue.length &&
                selection.end === value.length);
        };
        _this.onChange = function (event) {
            var beforePasteState = _this.beforePasteState;
            var previousSelection = _this.previousSelection;
            var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
            var value = _this.getInputValue();
            var previousValue = _this.value;
            var selection = _this.getSelection();
            // autofill replaces entire value, ignore old one
            // https://github.com/sanniassin/react-input-mask/issues/113
            if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
                previousValue = string_1.formatValue(_this.maskOptions, "");
                previousSelection = { start: 0, end: 0, length: 0 };
            }
            // set value and selection as if we haven't
            // cleared input in onPaste handler
            if (beforePasteState) {
                previousSelection = beforePasteState.selection;
                previousValue = beforePasteState.value;
                selection = {
                    start: previousSelection.start + value.length,
                    end: previousSelection.start + value.length,
                    length: 0
                };
                value =
                    previousValue.slice(0, previousSelection.start) +
                        value +
                        previousValue.slice(previousSelection.end);
                _this.beforePasteState = null;
            }
            var changedState = processChange_1.default(_this.maskOptions, value, selection, previousValue, previousSelection);
            var enteredString = changedState.enteredString;
            var newSelection = changedState.selection;
            var newValue = changedState.value;
            if (helpers_1.isFunction(beforeMaskedValueChange)) {
                var modifiedValue = beforeMaskedValueChange({ value: newValue, selection: newSelection }, { value: previousValue, selection: previousSelection }, enteredString, _this.getBeforeMaskedValueChangeConfig());
                newValue = modifiedValue.value;
                newSelection = modifiedValue.selection;
            }
            _this.setInputValue(newValue);
            if (helpers_1.isFunction(_this.props.onChange)) {
                _this.props.onChange(event);
            }
            if (_this.isWindowsPhoneBrowser) {
                _this.setSelection(newSelection.start, newSelection.end, {
                    deferred: true
                });
            }
            else {
                _this.setSelection(newSelection.start, newSelection.end);
            }
        };
        _this.onFocus = function (event) {
            var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
            var _a = _this.maskOptions, mask = _a.mask, prefix = _a.prefix;
            _this.focused = true;
            // if autoFocus is set, onFocus triggers before componentDidMount
            _this.mounted = true;
            if (mask) {
                if (!_this.value) {
                    var emptyValue = string_1.formatValue(_this.maskOptions, prefix);
                    var newValue = string_1.formatValue(_this.maskOptions, emptyValue);
                    var filledLength = string_1.getFilledLength(_this.maskOptions, newValue);
                    var cursorPosition = string_1.getRightEditablePosition(_this.maskOptions, filledLength);
                    var newSelection = { start: cursorPosition, end: cursorPosition };
                    if (helpers_1.isFunction(beforeMaskedValueChange)) {
                        var modifiedValue = beforeMaskedValueChange({ value: newValue, selection: newSelection }, { value: _this.value, selection: null }, null, _this.getBeforeMaskedValueChangeConfig());
                        newValue = modifiedValue.value;
                        newSelection = modifiedValue.selection;
                    }
                    var isInputValueChanged = newValue !== _this.getInputValue();
                    if (isInputValueChanged) {
                        _this.setInputValue(newValue);
                    }
                    if (isInputValueChanged && helpers_1.isFunction(_this.props.onChange)) {
                        _this.props.onChange(event);
                    }
                    _this.setSelection(newSelection.start, newSelection.end);
                }
                else if (string_1.getFilledLength(_this.maskOptions, _this.value) <
                    _this.maskOptions.mask.length) {
                    _this.setCursorToEnd();
                }
                _this.runSaveSelectionLoop();
            }
            if (helpers_1.isFunction(_this.props.onFocus)) {
                _this.props.onFocus(event);
            }
        };
        _this.onBlur = function (event) {
            var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
            var mask = _this.maskOptions.mask;
            _this.stopSaveSelectionLoop();
            _this.focused = false;
            if (mask &&
                !_this.props.alwaysShowMask &&
                string_1.isEmpty(_this.maskOptions, _this.value)) {
                var newValue = "";
                if (helpers_1.isFunction(beforeMaskedValueChange)) {
                    var modifiedValue = beforeMaskedValueChange({ value: newValue, selection: null }, { value: _this.value, selection: _this.previousSelection }, null, _this.getBeforeMaskedValueChangeConfig());
                    newValue = modifiedValue.value;
                }
                var isInputValueChanged = newValue !== _this.getInputValue();
                if (isInputValueChanged) {
                    _this.setInputValue(newValue);
                }
                if (isInputValueChanged && helpers_1.isFunction(_this.props.onChange)) {
                    _this.props.onChange(event);
                }
            }
            if (helpers_1.isFunction(_this.props.onBlur)) {
                _this.props.onBlur(event);
            }
        };
        _this.onMouseDown = function (event) {
            // tiny unintentional mouse movements can break cursor
            // position on focus, so we have to restore it in that case
            //
            // https://github.com/sanniassin/react-input-mask/issues/108
            if (!_this.focused && document.addEventListener) {
                _this.mouseDownX = event.clientX;
                _this.mouseDownY = event.clientY;
                _this.mouseDownTime = new Date().getTime();
                var mouseUpHandler_1 = function (mouseUpEvent) {
                    document.removeEventListener("mouseup", mouseUpHandler_1);
                    if (!_this.focused) {
                        return;
                    }
                    var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
                    var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
                    var axisDelta = Math.max(deltaX, deltaY);
                    var timeDelta = new Date().getTime() - _this.mouseDownTime;
                    if ((axisDelta <= 10 && timeDelta <= 200) ||
                        (axisDelta <= 5 && timeDelta <= 300)) {
                        _this.setCursorToEnd();
                    }
                };
                document.addEventListener("mouseup", mouseUpHandler_1);
            }
            if (helpers_1.isFunction(_this.props.onMouseDown)) {
                _this.props.onMouseDown(event);
            }
        };
        _this.onPaste = function (event) {
            if (helpers_1.isFunction(_this.props.onPaste)) {
                _this.props.onPaste(event);
            }
            // event.clipboardData might not work in Android browser
            // cleaning input to get raw text inside onChange handler
            if (!event.defaultPrevented) {
                _this.beforePasteState = {
                    value: _this.getInputValue(),
                    selection: _this.getSelection()
                };
                _this.setInputValue("");
            }
        };
        _this.handleRef = function (ref) {
            if (_this.props.children == null && helpers_1.isFunction(_this.props.inputRef)) {
                _this.props.inputRef(ref);
            }
        };
        var mask = props.mask, maskChar = props.maskChar, formatChars = props.formatChars, alwaysShowMask = props.alwaysShowMask, beforeMaskedValueChange = props.beforeMaskedValueChange;
        var defaultValue = props.defaultValue, value = props.value;
        _this.maskOptions = parseMask_1.default(mask, maskChar, formatChars);
        if (defaultValue == null) {
            defaultValue = "";
        }
        if (value == null) {
            value = defaultValue;
        }
        var newValue = string_1.getStringValue(value);
        if (_this.maskOptions.mask && (alwaysShowMask || newValue)) {
            newValue = string_1.formatValue(_this.maskOptions, newValue);
            if (helpers_1.isFunction(beforeMaskedValueChange)) {
                var oldValue = props.value;
                if (props.value == null) {
                    oldValue = defaultValue;
                }
                oldValue = string_1.getStringValue(oldValue);
                var modifiedValue = beforeMaskedValueChange({ value: newValue, selection: null }, { value: oldValue, selection: null }, null, _this.getBeforeMaskedValueChangeConfig());
                newValue = modifiedValue.value;
            }
        }
        _this.value = newValue;
        return _this;
    }
    InputElement.prototype.componentDidMount = function () {
        this.mounted = true;
        // workaround for react-test-renderer
        // https://github.com/sanniassin/react-input-mask/issues/147
        if (!this.getInputDOMNode()) {
            return;
        }
        this.isWindowsPhoneBrowser = environment_1.isWindowsPhoneBrowser();
        if (this.maskOptions.mask && this.getInputValue() !== this.value) {
            this.setInputValue(this.value);
        }
    };
    InputElement.prototype.componentDidUpdate = function () {
        var previousSelection = this.previousSelection;
        var _a = this.props, beforeMaskedValueChange = _a.beforeMaskedValueChange, alwaysShowMask = _a.alwaysShowMask, mask = _a.mask, maskChar = _a.maskChar, formatChars = _a.formatChars;
        var previousMaskOptions = this.maskOptions;
        var showEmpty = alwaysShowMask || this.isFocused();
        var hasValue = this.props.value != null;
        var newValue = hasValue ? string_1.getStringValue(this.props.value) : this.value;
        var cursorPosition = previousSelection ? previousSelection.start : null;
        this.maskOptions = parseMask_1.default(mask, maskChar, formatChars);
        if (!this.maskOptions.mask) {
            if (previousMaskOptions.mask) {
                this.stopSaveSelectionLoop();
                // render depends on this.maskOptions and this.value,
                // call forceUpdate to keep it in sync
                this.forceUpdate();
            }
            return;
        }
        else if (!previousMaskOptions.mask && this.isFocused()) {
            this.runSaveSelectionLoop();
        }
        var isMaskChanged = this.maskOptions.mask &&
            this.maskOptions.mask !== previousMaskOptions.mask;
        if (!previousMaskOptions.mask && !hasValue) {
            newValue = this.getInputValue();
        }
        if (isMaskChanged || (this.maskOptions.mask && (newValue || showEmpty))) {
            newValue = string_1.formatValue(this.maskOptions, newValue);
        }
        if (isMaskChanged) {
            var filledLength = string_1.getFilledLength(this.maskOptions, newValue);
            if (cursorPosition === null || filledLength < cursorPosition) {
                if (string_1.isFilled(this.maskOptions, newValue)) {
                    cursorPosition = filledLength;
                }
                else {
                    cursorPosition = string_1.getRightEditablePosition(this.maskOptions, filledLength);
                }
            }
        }
        if (this.maskOptions.mask &&
            string_1.isEmpty(this.maskOptions, newValue) &&
            !showEmpty &&
            (!hasValue || !this.props.value)) {
            newValue = "";
        }
        var newSelection = { start: cursorPosition, end: cursorPosition };
        if (helpers_1.isFunction(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({ value: newValue, selection: newSelection }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
        }
        this.value = newValue;
        var isValueChanged = this.getInputValue() !== this.value;
        // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync
        if (isValueChanged) {
            this.setInputValue(this.value);
            this.forceUpdate();
        }
        else if (isMaskChanged) {
            this.forceUpdate();
        }
        var isSelectionChanged = false;
        if (newSelection.start != null && newSelection.end != null) {
            isSelectionChanged =
                !previousSelection ||
                    previousSelection.start !== newSelection.start ||
                    previousSelection.end !== newSelection.end;
        }
        if (isSelectionChanged || isValueChanged) {
            this.setSelection(newSelection.start, newSelection.end);
        }
    };
    InputElement.prototype.componentWillUnmount = function () {
        this.mounted = false;
        if (this.selectionDeferId !== null) {
            defer_1.cancelDefer(this.selectionDeferId);
        }
        this.stopSaveSelectionLoop();
    };
    InputElement.prototype.render = function () {
        var _a = this.props, mask = _a.mask, alwaysShowMask = _a.alwaysShowMask, maskChar = _a.maskChar, formatChars = _a.formatChars, inputRef = _a.inputRef, beforeMaskedValueChange = _a.beforeMaskedValueChange, children = _a.children, restProps = __rest(_a, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
        var inputElement;
        warning_1.default(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !restProps.maxLength || !parseMask_1.default(mask, maskChar, formatChars).mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
        if (children) {
            invariant_1.default(helpers_1.isFunction(children), "react-input-mask: children must be a function");
            var controlledProps = [
                "onChange",
                "onPaste",
                "onMouseDown",
                "onFocus",
                "onBlur",
                "value",
                "disabled",
                "readOnly"
            ];
            var childrenProps_1 = __assign({}, restProps);
            controlledProps.forEach(function (propId) { return delete childrenProps_1[propId]; });
            inputElement = children(childrenProps_1);
            var conflictProps = controlledProps.filter(function (propId) {
                return inputElement.props[propId] != null &&
                    inputElement.props[propId] !== restProps[propId];
            });
            invariant_1.default(!conflictProps.length, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(", "));
            warning_1.default(!inputRef, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
        }
        else {
            inputElement = react_1.default.createElement("input", __assign({ ref: this.handleRef }, restProps));
        }
        var changedProps = {
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
        if (this.maskOptions.mask) {
            if (!restProps.disabled && !restProps.readOnly) {
                changedProps.onChange = this.onChange;
                changedProps.onPaste = this.onPaste;
                changedProps.onMouseDown = this.onMouseDown;
            }
            if (restProps.value != null) {
                changedProps.value = this.value;
            }
        }
        inputElement = react_1.default.cloneElement(inputElement, changedProps);
        return inputElement;
    };
    return InputElement;
}(react_1.default.Component));
exports.default = InputElement;
